import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";

/**
 * Generated class for the PpsToolComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: "pps-tool",
  templateUrl: "pps-tool.html",
})
export class PpsToolComponent implements OnInit {
  @Input() readonly: boolean = false;
  @Output() onValueUpdate: EventEmitter<any> = new EventEmitter();

  ambulationScore;
  activityScore;
  selfCareScore;
  intakeScore;
  consciousScore;
  assessorScoreExist;
  computedScore;
  assessorScore;
  assessorScoreHidden;
  innerGroup: FormGroup;
  default: string;

  readonlyAmbulation100: boolean = false;
  readonlyAmbulation90: boolean = false;
  readonlyAmbulation80: boolean = false;
  readonlyAmbulation70: boolean = false;
  readonlyAmbulation60: boolean = false;
  readonlyAmbulation50: boolean = false;
  readonlyAmbulation40: boolean = false;
  readonlyAmbulation30: boolean = false;
  readonlyAmbulation20: boolean = false;
  readonlyAmbulation10: boolean = false;
  readonlyAmbulation0: boolean = false;

  readonlyActivity100: boolean = false;
  readonlyActivity90: boolean = false;
  readonlyActivity80: boolean = false;
  readonlyActivity70: boolean = false;
  readonlyActivity60: boolean = false;
  readonlyActivity50: boolean = false;
  readonlyActivity40: boolean = false;
  readonlyActivity30: boolean = false;
  readonlyActivity20: boolean = false;
  readonlyActivity10: boolean = false;
  readonlyActivity0: boolean = false;

  readonlySelf100: boolean = false;
  readonlySelf90: boolean = false;
  readonlySelf80: boolean = false;
  readonlySelf70: boolean = false;
  readonlySelf60: boolean = false;
  readonlySelf50: boolean = false;
  readonlySelf40: boolean = false;
  readonlySelf30: boolean = false;
  readonlySelf20: boolean = false;
  readonlySelf10: boolean = false;
  readonlySelf0: boolean = false;

  readonlyIntake100: boolean = false;
  readonlyIntake90: boolean = false;
  readonlyIntake80: boolean = false;
  readonlyIntake70: boolean = false;
  readonlyIntake60: boolean = false;
  readonlyIntake50: boolean = false;
  readonlyIntake40: boolean = false;
  readonlyIntake30: boolean = false;
  readonlyIntake20: boolean = false;
  readonlyIntake10: boolean = false;
  readonlyIntake0: boolean = false;

  readonlyConscious100: boolean = false;
  readonlyConscious90: boolean = false;
  readonlyConscious80: boolean = false;
  readonlyConscious70: boolean = false;
  readonlyConscious60: boolean = false;
  readonlyConscious50: boolean = false;
  readonlyConscious40: boolean = false;
  readonlyConscious30: boolean = false;
  readonlyConscious20: boolean = false;
  readonlyConscious10: boolean = false;
  readonlyConscious0: boolean = false;

  constructor(public formBuilder: FormBuilder) {
    // console.log('Hello PpsToolComponent Component');
  }

  ngOnInit(): void {
    this.innerGroup = this.formBuilder.group({});
    let formState = this.default !== undefined ? this.default : null;
    this.innerGroup.addControl("ambRadio", this.formBuilder.control(formState));
    this.innerGroup.addControl("ambRadio", this.formBuilder.control(formState));
    this.innerGroup.addControl("actRadio", this.formBuilder.control(formState));
    this.innerGroup.addControl(
      "selfRadio",
      this.formBuilder.control(formState)
    );
    this.innerGroup.addControl(
      "intakeRadio",
      this.formBuilder.control(formState)
    );
    this.innerGroup.addControl(
      "consciousRadio",
      this.formBuilder.control(formState)
    );
    if (this.readonly) {
      this.disableEnableAll(true, true, true);
    }
  }

  @Input() set existingData(data: object) {
    // console.log( "Tool received existing data: ", data );
    if (!this.assessorScoreHidden) {
      if (data !== undefined && data !== null) {
        this.computeScore("none");
        if (data["ambulationScore"]) {
          this.disableSelected(data["ambulationScore"], "ambulation", false);
        }
        if (data["activityScore"]) {
          this.disableSelected(data["activityScore"], "activity", false);
        }
        if (data["selfCareScore"]) {
          this.disableSelected(data["selfCareScore"], "self", false);
        }
        if (data["intakeScore"]) {
          this.disableSelected(data["intakeScore"], "intake", false);
        }
        if (data["consciousScore"]) {
          this.disableSelected(data["consciousScore"], "conscious", false);
        }
      }
    }

    if (data !== undefined && data !== null) {
      if (data["assessorScore"] && !this.assessorScore) {
        this.assessorScore = data["assessorScore"];
        this.assessorScoreHidden = data["assessorScore"];
      }
      if (data["ambulationScore"] && !this.ambulationScore) {
        this.ambulationScore = data["ambulationScore"];
      }
      if (data["activityScore"] && !this.activityScore) {
        this.activityScore = data["activityScore"];
      }
      if (data["selfCareScore"] && !this.selfCareScore) {
        this.selfCareScore = data["selfCareScore"];
      }
      if (data["intakeScore"] && !this.intakeScore) {
        this.intakeScore = data["intakeScore"];
      }
      if (data["consciousScore"] && !this.consciousScore) {
        this.consciousScore = data["consciousScore"];
      }
    } else {
      this.disableEnableAll(true, true, false);
    }
  }

  ambulationChanged(value) {
    //console.log( "Updating ambulation value: ", value );
    this.ambulationScore = value;
    this.disableSelected(value, "ambulation", true);
    this.computeScore("change");
  }

  activityChanged(value) {
    // console.log( "Updating activity value: ", value );
    this.activityScore = value;
    this.disableSelected(value, "activity", true);
    this.computeScore("change");
  }

  selfCareChanged(value) {
    // console.log( "Updating self care value: ", value );
    this.selfCareScore = value;
    this.disableSelected(value, "self", true);
    this.computeScore("change");
  }

  intakeChanged(value) {
    // console.log( "Updating intake value: ", value );
    this.intakeScore = value;
    this.disableSelected(value, "intake", true);
    this.computeScore("change");
  }

  consciousChanged(value) {
    // console.log( "Updating conscious value: ", value );
    this.consciousScore = value;
    this.computeScore("change");
    this.disableSelected(value, "conscious", true);
  }

  assessorChanged(value) {
    // console.log( "Updating assessor value: ", value );
    this.assessorScore = value;
    this.computeScore("change");
  }

  computeScore(val) {
    let scoreSum = 0;
    let numScored = 0;

    if (this.ambulationScore !== undefined) {
      scoreSum += this.ambulationScore * 1;
      numScored++;
    }

    if (this.activityScore !== undefined) {
      scoreSum += this.activityScore * 1;
      numScored++;
    }

    if (this.selfCareScore !== undefined) {
      scoreSum += this.selfCareScore * 1;
      numScored++;
    }

    if (this.intakeScore !== undefined) {
      scoreSum += this.intakeScore * 1;
      numScored++;
    }

    if (this.consciousScore !== undefined) {
      scoreSum += this.consciousScore * 1;
      numScored++;
    }

    if (numScored == 0) {
      return;
    }

    // console.log( "Score sum: ", scoreSum );
    // console.log( "Num scored: ", numScored );
    this.computedScore = scoreSum / numScored;

    if (!this.readonly) {
      if (val == "change") {
        this.onValueUpdate.emit({
          assessorScore: this.assessorScore,
          ambulationScore: this.ambulationScore,
          activityScore: this.activityScore,
          selfCareScore: this.selfCareScore,
          intakeScore: this.intakeScore,
          consciousScore: this.consciousScore,
        });
      }
    }
  }

  clearValue(value) {
    this.innerGroup.controls.ambRadio.reset();
    this.innerGroup.controls.actRadio.reset();
    this.innerGroup.controls.selfRadio.reset();
    this.innerGroup.controls.intakeRadio.reset();
    this.innerGroup.controls.consciousRadio.reset();
    this.ambulationScore = "";
    this.activityScore = "";
    this.selfCareScore = "";
    this.intakeScore = "";
    this.consciousScore = "";
    this.assessorScore = "";
    this.disableEnableAll(true, true, false);
    this.computeScore("change");
  }

  disableEnableAll(val, initialPop, initialValue) {
    if (initialPop) {
      this.readonlyAmbulation100 = initialValue;
      this.readonlyAmbulation90 = initialValue;
      this.readonlyAmbulation80 = initialValue;
      this.readonlyAmbulation70 = initialValue;
      this.readonlyAmbulation60 = initialValue;
      this.readonlyAmbulation50 = initialValue;
      this.readonlyAmbulation40 = initialValue;
      this.readonlyAmbulation30 = initialValue;
      this.readonlyAmbulation20 = initialValue;
      this.readonlyAmbulation10 = initialValue;
      this.readonlyAmbulation0 = initialValue;
    }
    this.readonlyActivity100 = val;
    this.readonlyActivity90 = val;
    this.readonlyActivity80 = val;
    this.readonlyActivity70 = val;
    this.readonlyActivity60 = val;
    this.readonlyActivity50 = val;
    this.readonlyActivity40 = val;
    this.readonlyActivity30 = val;
    this.readonlyActivity20 = val;
    this.readonlyActivity10 = val;
    this.readonlyActivity0 = val;

    this.readonlySelf100 = val;
    this.readonlySelf90 = val;
    this.readonlySelf80 = val;
    this.readonlySelf70 = val;
    this.readonlySelf60 = val;
    this.readonlySelf50 = val;
    this.readonlySelf40 = val;
    this.readonlySelf30 = val;
    this.readonlySelf20 = val;
    this.readonlySelf10 = val;
    this.readonlySelf0 = val;

    this.readonlyIntake100 = val;
    this.readonlyIntake90 = val;
    this.readonlyIntake80 = val;
    this.readonlyIntake70 = val;
    this.readonlyIntake60 = val;
    this.readonlyIntake50 = val;
    this.readonlyIntake40 = val;
    this.readonlyIntake30 = val;
    this.readonlyIntake20 = val;
    this.readonlyIntake10 = val;
    this.readonlyIntake0 = val;

    this.readonlyConscious100 = val;
    this.readonlyConscious90 = val;
    this.readonlyConscious80 = val;
    this.readonlyConscious70 = val;
    this.readonlyConscious60 = val;
    this.readonlyConscious50 = val;
    this.readonlyConscious40 = val;
    this.readonlyConscious30 = val;
    this.readonlyConscious20 = val;
    this.readonlyConscious10 = val;
    this.readonlyConscious0 = val;
  }

  disableSelected(value, type, clear) {
    if (type == "ambulation") {
      if (clear) {
        this.innerGroup.controls.actRadio.reset();
        this.innerGroup.controls.selfRadio.reset();
        this.innerGroup.controls.intakeRadio.reset();
        this.innerGroup.controls.consciousRadio.reset();

        this.readonlySelf100 = true;
        this.readonlySelf90 = true;
        this.readonlySelf80 = true;
        this.readonlySelf70 = true;
        this.readonlySelf60 = true;
        this.readonlySelf50 = true;
        this.readonlySelf40 = true;
        this.readonlySelf30 = true;
        this.readonlySelf20 = true;
        this.readonlySelf10 = true;
        this.readonlySelf0 = true;

        this.readonlyIntake100 = true;
        this.readonlyIntake90 = true;
        this.readonlyIntake80 = true;
        this.readonlyIntake70 = true;
        this.readonlyIntake60 = true;
        this.readonlyIntake50 = true;
        this.readonlyIntake40 = true;
        this.readonlyIntake30 = true;
        this.readonlyIntake20 = true;
        this.readonlyIntake10 = true;
        this.readonlyIntake0 = true;

        this.readonlyConscious100 = true;
        this.readonlyConscious90 = true;
        this.readonlyConscious80 = true;
        this.readonlyConscious70 = true;
        this.readonlyConscious60 = true;
        this.readonlyConscious50 = true;
        this.readonlyConscious40 = true;
        this.readonlyConscious30 = true;
        this.readonlyConscious20 = true;
        this.readonlyConscious10 = true;
        this.readonlyConscious0 = true;
      }
      if (value == 100) {
        this.readonlyActivity100 = false;
        this.readonlyActivity90 = false;
        this.readonlyActivity80 = false;
        this.readonlyActivity70 = false;
        this.readonlyActivity60 = false;
        this.readonlyActivity50 = false;
        this.readonlyActivity40 = false;
        this.readonlyActivity30 = false;
        this.readonlyActivity20 = false;
        this.readonlyActivity10 = false;
        this.readonlyActivity0 = false;
      } else if (value == 90) {
        this.readonlyActivity90 = false;
        this.readonlyActivity80 = false;
        this.readonlyActivity70 = false;
        this.readonlyActivity60 = false;
        this.readonlyActivity50 = false;
        this.readonlyActivity40 = false;
        this.readonlyActivity30 = false;
        this.readonlyActivity20 = false;
        this.readonlyActivity10 = false;
        this.readonlyActivity0 = false;

        this.readonlyAmbulation100 = true;
        this.readonlyActivity100 = true;
      } else if (value == 80) {
        this.readonlyActivity80 = false;
        this.readonlyActivity70 = false;
        this.readonlyActivity60 = false;
        this.readonlyActivity50 = false;
        this.readonlyActivity40 = false;
        this.readonlyActivity30 = false;
        this.readonlyActivity20 = false;
        this.readonlyActivity10 = false;
        this.readonlyActivity0 = false;

        this.readonlyAmbulation100 = true;
        this.readonlyActivity100 = true;
        this.readonlyAmbulation90 = true;
        this.readonlyActivity90 = true;
      } else if (value == 70) {
        this.readonlyActivity70 = false;
        this.readonlyActivity60 = false;
        this.readonlyActivity50 = false;
        this.readonlyActivity40 = false;
        this.readonlyActivity30 = false;
        this.readonlyActivity20 = false;
        this.readonlyActivity10 = false;
        this.readonlyActivity0 = false;

        this.readonlyAmbulation100 = true;
        this.readonlyActivity100 = true;
        this.readonlyAmbulation90 = true;
        this.readonlyActivity90 = true;
        this.readonlyAmbulation80 = true;
        this.readonlyActivity80 = true;
      } else if (value == 60) {
        this.readonlyActivity60 = false;
        this.readonlyActivity50 = false;
        this.readonlyActivity40 = false;
        this.readonlyActivity30 = false;
        this.readonlyActivity20 = false;
        this.readonlyActivity10 = false;
        this.readonlyActivity0 = false;

        this.readonlyAmbulation100 = true;
        this.readonlyActivity100 = true;
        this.readonlyAmbulation90 = true;
        this.readonlyActivity90 = true;
        this.readonlyAmbulation80 = true;
        this.readonlyActivity80 = true;
        this.readonlyAmbulation70 = true;
        this.readonlyActivity70 = true;
      } else if (value == 50) {
        this.readonlyActivity50 = false;
        this.readonlyActivity40 = false;
        this.readonlyActivity30 = false;
        this.readonlyActivity20 = false;
        this.readonlyActivity10 = false;
        this.readonlyActivity0 = false;

        this.readonlyAmbulation100 = true;
        this.readonlyActivity100 = true;
        this.readonlyAmbulation90 = true;
        this.readonlyActivity90 = true;
        this.readonlyAmbulation80 = true;
        this.readonlyActivity80 = true;
        this.readonlyAmbulation70 = true;
        this.readonlyActivity70 = true;
        this.readonlyAmbulation60 = true;
        this.readonlyActivity60 = true;
      } else if (value == 40) {
        this.readonlyActivity40 = false;
        this.readonlyActivity30 = false;
        this.readonlyActivity20 = false;
        this.readonlyActivity10 = false;
        this.readonlyActivity0 = false;

        this.readonlyAmbulation100 = true;
        this.readonlyActivity100 = true;
        this.readonlyAmbulation90 = true;
        this.readonlyActivity90 = true;
        this.readonlyAmbulation80 = true;
        this.readonlyActivity80 = true;
        this.readonlyAmbulation70 = true;
        this.readonlyActivity70 = true;
        this.readonlyAmbulation60 = true;
        this.readonlyActivity60 = true;
        this.readonlyAmbulation50 = true;
        this.readonlyActivity50 = true;
      } else if (value == 30) {
        this.readonlyActivity30 = false;
        this.readonlyActivity20 = false;
        this.readonlyActivity10 = false;
        this.readonlyActivity0 = false;

        this.readonlyAmbulation100 = true;
        this.readonlyActivity100 = true;
        this.readonlyAmbulation90 = true;
        this.readonlyActivity90 = true;
        this.readonlyAmbulation80 = true;
        this.readonlyActivity80 = true;
        this.readonlyAmbulation70 = true;
        this.readonlyActivity70 = true;
        this.readonlyAmbulation60 = true;
        this.readonlyActivity60 = true;
        this.readonlyAmbulation50 = true;
        this.readonlyActivity50 = true;
        this.readonlyAmbulation40 = true;
        this.readonlyActivity40 = true;
      } else if (value == 20) {
        this.readonlyActivity20 = false;
        this.readonlyActivity10 = false;
        this.readonlyActivity0 = false;

        this.readonlyAmbulation100 = true;
        this.readonlyActivity100 = true;
        this.readonlyAmbulation90 = true;
        this.readonlyActivity90 = true;
        this.readonlyAmbulation80 = true;
        this.readonlyActivity80 = true;
        this.readonlyAmbulation70 = true;
        this.readonlyActivity70 = true;
        this.readonlyAmbulation60 = true;
        this.readonlyActivity60 = true;
        this.readonlyAmbulation50 = true;
        this.readonlyActivity50 = true;
        this.readonlyAmbulation40 = true;
        this.readonlyActivity40 = true;
        this.readonlyAmbulation30 = true;
        this.readonlyActivity30 = true;
      } else if (value == 10) {
        this.readonlyActivity10 = false;
        this.readonlyActivity0 = false;

        this.readonlyAmbulation100 = true;
        this.readonlyActivity100 = true;
        this.readonlyAmbulation90 = true;
        this.readonlyActivity90 = true;
        this.readonlyAmbulation80 = true;
        this.readonlyActivity80 = true;
        this.readonlyAmbulation70 = true;
        this.readonlyActivity70 = true;
        this.readonlyAmbulation60 = true;
        this.readonlyActivity60 = true;
        this.readonlyAmbulation50 = true;
        this.readonlyActivity50 = true;
        this.readonlyAmbulation40 = true;
        this.readonlyActivity40 = true;
        this.readonlyAmbulation30 = true;
        this.readonlyActivity30 = true;
        this.readonlyAmbulation20 = true;
        this.readonlyActivity20 = true;
      } else if (value == 0) {
        this.readonlyActivity0 = false;

        this.readonlyAmbulation100 = true;
        this.readonlyActivity100 = true;
        this.readonlyAmbulation90 = true;
        this.readonlyActivity90 = true;
        this.readonlyAmbulation80 = true;
        this.readonlyActivity80 = true;
        this.readonlyAmbulation70 = true;
        this.readonlyActivity70 = true;
        this.readonlyAmbulation60 = true;
        this.readonlyActivity60 = true;
        this.readonlyAmbulation50 = true;
        this.readonlyActivity50 = true;
        this.readonlyAmbulation40 = true;
        this.readonlyActivity40 = true;
        this.readonlyAmbulation30 = true;
        this.readonlyActivity30 = true;
        this.readonlyAmbulation20 = true;
        this.readonlyActivity20 = true;
        this.readonlyAmbulation10 = true;
        this.readonlyActivity10 = true;
      }
    } else if (type == "activity") {
      if (clear) {
        this.innerGroup.controls.selfRadio.reset();
        this.innerGroup.controls.intakeRadio.reset();
        this.innerGroup.controls.consciousRadio.reset();

        this.readonlyIntake100 = true;
        this.readonlyIntake90 = true;
        this.readonlyIntake80 = true;
        this.readonlyIntake70 = true;
        this.readonlyIntake60 = true;
        this.readonlyIntake50 = true;
        this.readonlyIntake40 = true;
        this.readonlyIntake30 = true;
        this.readonlyIntake20 = true;
        this.readonlyIntake10 = true;
        this.readonlyIntake0 = true;

        this.readonlyConscious100 = true;
        this.readonlyConscious90 = true;
        this.readonlyConscious80 = true;
        this.readonlyConscious70 = true;
        this.readonlyConscious60 = true;
        this.readonlyConscious50 = true;
        this.readonlyConscious40 = true;
        this.readonlyConscious30 = true;
        this.readonlyConscious20 = true;
        this.readonlyConscious10 = true;
        this.readonlyConscious0 = true;
      }
      if (value == 100) {
        this.readonlySelf100 = false;
        this.readonlySelf90 = false;
        this.readonlySelf80 = false;
        this.readonlySelf70 = false;
        this.readonlySelf60 = false;
        this.readonlySelf50 = false;
        this.readonlySelf40 = false;
        this.readonlySelf30 = false;
        this.readonlySelf20 = false;
        this.readonlySelf10 = false;
        this.readonlySelf0 = false;
      } else if (value == 90) {
        this.readonlySelf90 = false;
        this.readonlySelf80 = false;
        this.readonlySelf70 = false;
        this.readonlySelf60 = false;
        this.readonlySelf50 = false;
        this.readonlySelf40 = false;
        this.readonlySelf30 = false;
        this.readonlySelf20 = false;
        this.readonlySelf10 = false;
        this.readonlySelf0 = false;

        this.readonlyActivity100 = true;
        this.readonlySelf100 = true;
      } else if (value == 80) {
        this.readonlySelf80 = false;
        this.readonlySelf70 = false;
        this.readonlySelf60 = false;
        this.readonlySelf50 = false;
        this.readonlySelf40 = false;
        this.readonlySelf30 = false;
        this.readonlySelf20 = false;
        this.readonlySelf10 = false;
        this.readonlySelf0 = false;

        this.readonlyActivity100 = true;
        this.readonlySelf100 = true;
        this.readonlyActivity90 = true;
        this.readonlySelf90 = true;
      } else if (value == 70) {
        this.readonlySelf70 = false;
        this.readonlySelf60 = false;
        this.readonlySelf50 = false;
        this.readonlySelf40 = false;
        this.readonlySelf30 = false;
        this.readonlySelf20 = false;
        this.readonlySelf10 = false;
        this.readonlySelf0 = false;

        this.readonlyActivity100 = true;
        this.readonlySelf100 = true;
        this.readonlyActivity90 = true;
        this.readonlySelf90 = true;
        this.readonlyActivity80 = true;
        this.readonlySelf80 = true;
      } else if (value == 60) {
        this.readonlySelf60 = false;
        this.readonlySelf50 = false;
        this.readonlySelf40 = false;
        this.readonlySelf30 = false;
        this.readonlySelf20 = false;
        this.readonlySelf10 = false;
        this.readonlySelf0 = false;

        this.readonlyActivity100 = true;
        this.readonlySelf100 = true;
        this.readonlyActivity90 = true;
        this.readonlySelf90 = true;
        this.readonlyActivity80 = true;
        this.readonlySelf80 = true;
        this.readonlyActivity70 = true;
        this.readonlySelf70 = true;
      } else if (value == 50) {
        this.readonlySelf50 = false;
        this.readonlySelf40 = false;
        this.readonlySelf30 = false;
        this.readonlySelf20 = false;
        this.readonlySelf10 = false;
        this.readonlySelf0 = false;

        this.readonlyActivity100 = true;
        this.readonlySelf100 = true;
        this.readonlyActivity90 = true;
        this.readonlySelf90 = true;
        this.readonlyActivity80 = true;
        this.readonlySelf80 = true;
        this.readonlyActivity70 = true;
        this.readonlySelf70 = true;
        this.readonlyActivity60 = true;
        this.readonlySelf60 = true;
      } else if (value == 40) {
        this.readonlySelf40 = false;
        this.readonlySelf30 = false;
        this.readonlySelf20 = false;
        this.readonlySelf10 = false;
        this.readonlySelf0 = false;

        this.readonlyActivity100 = true;
        this.readonlySelf100 = true;
        this.readonlyActivity90 = true;
        this.readonlySelf90 = true;
        this.readonlyActivity80 = true;
        this.readonlySelf80 = true;
        this.readonlyActivity70 = true;
        this.readonlySelf70 = true;
        this.readonlyActivity60 = true;
        this.readonlySelf60 = true;
        this.readonlyActivity50 = true;
        this.readonlySelf50 = true;
      } else if (value == 30) {
        this.readonlySelf30 = false;
        this.readonlySelf20 = false;
        this.readonlySelf10 = false;
        this.readonlySelf0 = false;

        this.readonlyActivity100 = true;
        this.readonlySelf100 = true;
        this.readonlyActivity90 = true;
        this.readonlySelf90 = true;
        this.readonlyActivity80 = true;
        this.readonlySelf80 = true;
        this.readonlyActivity70 = true;
        this.readonlySelf70 = true;
        this.readonlyActivity60 = true;
        this.readonlySelf60 = true;
        this.readonlyActivity50 = true;
        this.readonlySelf50 = true;
        this.readonlyActivity40 = true;
        this.readonlySelf40 = true;
      } else if (value == 20) {
        this.readonlySelf20 = false;
        this.readonlySelf10 = false;
        this.readonlySelf0 = false;

        this.readonlyActivity100 = true;
        this.readonlySelf100 = true;
        this.readonlyActivity90 = true;
        this.readonlySelf90 = true;
        this.readonlyActivity80 = true;
        this.readonlySelf80 = true;
        this.readonlyActivity70 = true;
        this.readonlySelf70 = true;
        this.readonlyActivity60 = true;
        this.readonlySelf60 = true;
        this.readonlyActivity50 = true;
        this.readonlySelf50 = true;
        this.readonlyActivity40 = true;
        this.readonlySelf40 = true;
        this.readonlyActivity30 = true;
        this.readonlySelf30 = true;
      } else if (value == 10) {
        this.readonlySelf10 = false;
        this.readonlySelf0 = false;

        this.readonlyActivity100 = true;
        this.readonlySelf100 = true;
        this.readonlyActivity90 = true;
        this.readonlySelf90 = true;
        this.readonlyActivity80 = true;
        this.readonlySelf80 = true;
        this.readonlyActivity70 = true;
        this.readonlySelf70 = true;
        this.readonlyActivity60 = true;
        this.readonlySelf60 = true;
        this.readonlyActivity50 = true;
        this.readonlySelf50 = true;
        this.readonlyActivity40 = true;
        this.readonlySelf40 = true;
        this.readonlyActivity30 = true;
        this.readonlySelf30 = true;
        this.readonlyActivity20 = true;
        this.readonlySelf20 = true;
      } else if (value == 0) {
        this.readonlySelf0 = false;

        this.readonlyActivity100 = true;
        this.readonlySelf100 = true;
        this.readonlyActivity90 = true;
        this.readonlySelf90 = true;
        this.readonlyActivity80 = true;
        this.readonlySelf80 = true;
        this.readonlyActivity70 = true;
        this.readonlySelf70 = true;
        this.readonlyActivity60 = true;
        this.readonlySelf60 = true;
        this.readonlyActivity50 = true;
        this.readonlySelf50 = true;
        this.readonlyActivity40 = true;
        this.readonlySelf40 = true;
        this.readonlyActivity30 = true;
        this.readonlySelf30 = true;
        this.readonlyActivity20 = true;
        this.readonlySelf20 = true;
        this.readonlyActivity10 = true;
        this.readonlySelf10 = true;
      }
    } else if (type == "self") {
      if (clear) {
        this.innerGroup.controls.intakeRadio.reset();
        this.innerGroup.controls.consciousRadio.reset();

        this.readonlyConscious100 = true;
        this.readonlyConscious90 = true;
        this.readonlyConscious80 = true;
        this.readonlyConscious70 = true;
        this.readonlyConscious60 = true;
        this.readonlyConscious50 = true;
        this.readonlyConscious40 = true;
        this.readonlyConscious30 = true;
        this.readonlyConscious20 = true;
        this.readonlyConscious10 = true;
        this.readonlyConscious0 = true;
      }
      if (value == 100) {
        this.readonlyIntake100 = false;
        this.readonlyIntake90 = false;
        this.readonlyIntake80 = false;
        this.readonlyIntake70 = false;
        this.readonlyIntake60 = false;
        this.readonlyIntake50 = false;
        this.readonlyIntake40 = false;
        this.readonlyIntake30 = false;
        this.readonlyIntake20 = false;
        this.readonlyIntake10 = false;
        this.readonlyIntake0 = false;
      } else if (value == 90) {
        this.readonlyIntake90 = false;
        this.readonlyIntake80 = false;
        this.readonlyIntake70 = false;
        this.readonlyIntake60 = false;
        this.readonlyIntake50 = false;
        this.readonlyIntake40 = false;
        this.readonlyIntake30 = false;
        this.readonlyIntake20 = false;
        this.readonlyIntake10 = false;
        this.readonlyIntake0 = false;

        this.readonlySelf100 = true;
        this.readonlyIntake100 = true;
      } else if (value == 80) {
        this.readonlyIntake80 = false;
        this.readonlyIntake70 = false;
        this.readonlyIntake60 = false;
        this.readonlyIntake50 = false;
        this.readonlyIntake40 = false;
        this.readonlyIntake30 = false;
        this.readonlyIntake20 = false;
        this.readonlyIntake10 = false;
        this.readonlyIntake0 = false;

        this.readonlySelf100 = true;
        this.readonlyIntake100 = true;
        this.readonlySelf90 = true;
        this.readonlyIntake90 = true;
      } else if (value == 70) {
        this.readonlyIntake70 = false;
        this.readonlyIntake60 = false;
        this.readonlyIntake50 = false;
        this.readonlyIntake40 = false;
        this.readonlyIntake30 = false;
        this.readonlyIntake20 = false;
        this.readonlyIntake10 = false;
        this.readonlyIntake0 = false;

        this.readonlySelf100 = true;
        this.readonlyIntake100 = true;
        this.readonlySelf90 = true;
        this.readonlyIntake90 = true;
        this.readonlySelf80 = true;
        this.readonlyIntake80 = true;
      } else if (value == 60) {
        this.readonlyIntake60 = false;
        this.readonlyIntake50 = false;
        this.readonlyIntake40 = false;
        this.readonlyIntake30 = false;
        this.readonlyIntake20 = false;
        this.readonlyIntake10 = false;
        this.readonlyIntake0 = false;

        this.readonlySelf100 = true;
        this.readonlyIntake100 = true;
        this.readonlySelf90 = true;
        this.readonlyIntake90 = true;
        this.readonlySelf80 = true;
        this.readonlyIntake80 = true;
        this.readonlySelf70 = true;
        this.readonlyIntake70 = true;
      } else if (value == 50) {
        this.readonlyIntake50 = false;
        this.readonlyIntake40 = false;
        this.readonlyIntake30 = false;
        this.readonlyIntake20 = false;
        this.readonlyIntake10 = false;
        this.readonlyIntake0 = false;

        this.readonlySelf100 = true;
        this.readonlyIntake100 = true;
        this.readonlySelf90 = true;
        this.readonlyIntake90 = true;
        this.readonlySelf80 = true;
        this.readonlyIntake80 = true;
        this.readonlySelf70 = true;
        this.readonlyIntake70 = true;
        this.readonlySelf60 = true;
        this.readonlyIntake60 = true;
      } else if (value == 40) {
        this.readonlyIntake40 = false;
        this.readonlyIntake30 = false;
        this.readonlyIntake20 = false;
        this.readonlyIntake10 = false;
        this.readonlyIntake0 = false;

        this.readonlySelf100 = true;
        this.readonlyIntake100 = true;
        this.readonlySelf90 = true;
        this.readonlyIntake90 = true;
        this.readonlySelf80 = true;
        this.readonlyIntake80 = true;
        this.readonlySelf70 = true;
        this.readonlyIntake70 = true;
        this.readonlySelf60 = true;
        this.readonlyIntake60 = true;
        this.readonlySelf50 = true;
        this.readonlyIntake50 = true;
      } else if (value == 30) {
        this.readonlyIntake30 = false;
        this.readonlyIntake20 = false;
        this.readonlyIntake10 = false;
        this.readonlyIntake0 = false;

        this.readonlySelf100 = true;
        this.readonlyIntake100 = true;
        this.readonlySelf90 = true;
        this.readonlyIntake90 = true;
        this.readonlySelf80 = true;
        this.readonlyIntake80 = true;
        this.readonlySelf70 = true;
        this.readonlyIntake70 = true;
        this.readonlySelf60 = true;
        this.readonlyIntake60 = true;
        this.readonlySelf50 = true;
        this.readonlyIntake50 = true;
        this.readonlySelf40 = true;
        this.readonlyIntake40 = true;
      } else if (value == 20) {
        this.readonlyIntake20 = false;
        this.readonlyIntake10 = false;
        this.readonlyIntake0 = false;

        this.readonlySelf100 = true;
        this.readonlyIntake100 = true;
        this.readonlySelf90 = true;
        this.readonlyIntake90 = true;
        this.readonlySelf80 = true;
        this.readonlyIntake80 = true;
        this.readonlySelf70 = true;
        this.readonlyIntake70 = true;
        this.readonlySelf60 = true;
        this.readonlyIntake60 = true;
        this.readonlySelf50 = true;
        this.readonlyIntake50 = true;
        this.readonlySelf40 = true;
        this.readonlyIntake40 = true;
        this.readonlySelf30 = true;
        this.readonlyIntake30 = true;
      } else if (value == 10) {
        this.readonlyIntake10 = false;
        this.readonlyIntake0 = false;

        this.readonlySelf100 = true;
        this.readonlyIntake100 = true;
        this.readonlySelf90 = true;
        this.readonlyIntake90 = true;
        this.readonlySelf80 = true;
        this.readonlyIntake80 = true;
        this.readonlySelf70 = true;
        this.readonlyIntake70 = true;
        this.readonlySelf60 = true;
        this.readonlyIntake60 = true;
        this.readonlySelf50 = true;
        this.readonlyIntake50 = true;
        this.readonlySelf40 = true;
        this.readonlyIntake40 = true;
        this.readonlySelf30 = true;
        this.readonlyIntake30 = true;
        this.readonlySelf20 = true;
        this.readonlyIntake20 = true;
      } else if (value == 0) {
        this.readonlyIntake0 = false;

        this.readonlySelf100 = true;
        this.readonlyIntake100 = true;
        this.readonlySelf90 = true;
        this.readonlyIntake90 = true;
        this.readonlySelf80 = true;
        this.readonlyIntake80 = true;
        this.readonlySelf70 = true;
        this.readonlyIntake70 = true;
        this.readonlySelf60 = true;
        this.readonlyIntake60 = true;
        this.readonlySelf50 = true;
        this.readonlyIntake50 = true;
        this.readonlySelf40 = true;
        this.readonlyIntake40 = true;
        this.readonlySelf30 = true;
        this.readonlyIntake30 = true;
        this.readonlySelf20 = true;
        this.readonlyIntake20 = true;
        this.readonlySelf10 = true;
        this.readonlyIntake10 = true;
      }
    } else if (type == "intake") {
      if (clear) {
        this.innerGroup.controls.consciousRadio.reset();
      }
      if (value == 100) {
        this.readonlyConscious100 = false;
        this.readonlyConscious90 = false;
        this.readonlyConscious80 = false;
        this.readonlyConscious70 = false;
        this.readonlyConscious60 = false;
        this.readonlyConscious50 = false;
        this.readonlyConscious40 = false;
        this.readonlyConscious30 = false;
        this.readonlyConscious20 = false;
        this.readonlyConscious10 = false;
        this.readonlyConscious0 = false;
      } else if (value == 90) {
        this.readonlyConscious90 = false;
        this.readonlyConscious80 = false;
        this.readonlyConscious70 = false;
        this.readonlyConscious60 = false;
        this.readonlyConscious50 = false;
        this.readonlyConscious40 = false;
        this.readonlyConscious30 = false;
        this.readonlyConscious20 = false;
        this.readonlyConscious10 = false;
        this.readonlyConscious0 = false;

        this.readonlyIntake100 = true;
        this.readonlyConscious100 = true;
      } else if (value == 80) {
        this.readonlyConscious80 = false;
        this.readonlyConscious70 = false;
        this.readonlyConscious60 = false;
        this.readonlyConscious50 = false;
        this.readonlyConscious40 = false;
        this.readonlyConscious30 = false;
        this.readonlyConscious20 = false;
        this.readonlyConscious10 = false;
        this.readonlyConscious0 = false;

        this.readonlyIntake100 = true;
        this.readonlyConscious100 = true;
        this.readonlyIntake90 = true;
        this.readonlyConscious90 = true;
      } else if (value == 70) {
        this.readonlyConscious70 = false;
        this.readonlyConscious60 = false;
        this.readonlyConscious50 = false;
        this.readonlyConscious40 = false;
        this.readonlyConscious30 = false;
        this.readonlyConscious20 = false;
        this.readonlyConscious10 = false;
        this.readonlyConscious0 = false;

        this.readonlyIntake100 = true;
        this.readonlyConscious100 = true;
        this.readonlyIntake90 = true;
        this.readonlyConscious90 = true;
        this.readonlyIntake80 = true;
        this.readonlyConscious80 = true;
      } else if (value == 60) {
        this.readonlyConscious60 = false;
        this.readonlyConscious50 = false;
        this.readonlyConscious40 = false;
        this.readonlyConscious30 = false;
        this.readonlyConscious20 = false;
        this.readonlyConscious10 = false;
        this.readonlyConscious0 = false;

        this.readonlyIntake100 = true;
        this.readonlyConscious100 = true;
        this.readonlyIntake90 = true;
        this.readonlyConscious90 = true;
        this.readonlyIntake80 = true;
        this.readonlyConscious80 = true;
        this.readonlyIntake70 = true;
        this.readonlyConscious70 = true;
      } else if (value == 50) {
        this.readonlyConscious50 = false;
        this.readonlyConscious40 = false;
        this.readonlyConscious30 = false;
        this.readonlyConscious20 = false;
        this.readonlyConscious10 = false;
        this.readonlyConscious0 = false;

        this.readonlyIntake100 = true;
        this.readonlyConscious100 = true;
        this.readonlyIntake90 = true;
        this.readonlyConscious90 = true;
        this.readonlyIntake80 = true;
        this.readonlyConscious80 = true;
        this.readonlyIntake70 = true;
        this.readonlyConscious70 = true;
        this.readonlyIntake60 = true;
        this.readonlyConscious60 = true;
      } else if (value == 40) {
        this.readonlyConscious40 = false;
        this.readonlyConscious30 = false;
        this.readonlyConscious20 = false;
        this.readonlyConscious10 = false;
        this.readonlyConscious0 = false;

        this.readonlyIntake100 = true;
        this.readonlyConscious100 = true;
        this.readonlyIntake90 = true;
        this.readonlyConscious90 = true;
        this.readonlyIntake80 = true;
        this.readonlyConscious80 = true;
        this.readonlyIntake70 = true;
        this.readonlyConscious70 = true;
        this.readonlyIntake60 = true;
        this.readonlyConscious60 = true;
        this.readonlyIntake50 = true;
        this.readonlyConscious50 = true;
      } else if (value == 30) {
        this.readonlyConscious30 = false;
        this.readonlyConscious20 = false;
        this.readonlyConscious10 = false;
        this.readonlyConscious0 = false;

        this.readonlyIntake100 = true;
        this.readonlyConscious100 = true;
        this.readonlyIntake90 = true;
        this.readonlyConscious90 = true;
        this.readonlyIntake80 = true;
        this.readonlyConscious80 = true;
        this.readonlyIntake70 = true;
        this.readonlyConscious70 = true;
        this.readonlyIntake60 = true;
        this.readonlyConscious60 = true;
        this.readonlyIntake50 = true;
        this.readonlyConscious50 = true;
        this.readonlyIntake40 = true;
        this.readonlyConscious40 = true;
      } else if (value == 20) {
        this.readonlyConscious20 = false;
        this.readonlyConscious10 = false;
        this.readonlyConscious0 = false;

        this.readonlyIntake100 = true;
        this.readonlyConscious100 = true;
        this.readonlyIntake90 = true;
        this.readonlyConscious90 = true;
        this.readonlyIntake80 = true;
        this.readonlyConscious80 = true;
        this.readonlyIntake70 = true;
        this.readonlyConscious70 = true;
        this.readonlyIntake60 = true;
        this.readonlyConscious60 = true;
        this.readonlyIntake50 = true;
        this.readonlyConscious50 = true;
        this.readonlyIntake40 = true;
        this.readonlyConscious40 = true;
        this.readonlyIntake30 = true;
        this.readonlyConscious30 = true;
      } else if (value == 10) {
        this.readonlyConscious10 = false;
        this.readonlyConscious0 = false;

        this.readonlyIntake100 = true;
        this.readonlyConscious100 = true;
        this.readonlyIntake90 = true;
        this.readonlyConscious90 = true;
        this.readonlyIntake80 = true;
        this.readonlyConscious80 = true;
        this.readonlyIntake70 = true;
        this.readonlyConscious70 = true;
        this.readonlyIntake60 = true;
        this.readonlyConscious60 = true;
        this.readonlyIntake50 = true;
        this.readonlyConscious50 = true;
        this.readonlyIntake40 = true;
        this.readonlyConscious40 = true;
        this.readonlyIntake30 = true;
        this.readonlyConscious30 = true;
        this.readonlyIntake20 = true;
        this.readonlyConscious20 = true;
      } else if (value == 0) {
        this.readonlyConscious0 = false;

        this.readonlyIntake100 = true;
        this.readonlyConscious100 = true;
        this.readonlyIntake90 = true;
        this.readonlyConscious90 = true;
        this.readonlyIntake80 = true;
        this.readonlyConscious80 = true;
        this.readonlyIntake70 = true;
        this.readonlyConscious70 = true;
        this.readonlyIntake60 = true;
        this.readonlyConscious60 = true;
        this.readonlyIntake50 = true;
        this.readonlyConscious50 = true;
        this.readonlyIntake40 = true;
        this.readonlyConscious40 = true;
        this.readonlyIntake30 = true;
        this.readonlyConscious30 = true;
        this.readonlyIntake20 = true;
        this.readonlyConscious20 = true;
        this.readonlyIntake10 = true;
        this.readonlyConscious10 = true;
      }
    } else if (type == "conscious") {
      if (value == 90) {
        this.readonlyConscious100 = true;
      } else if (value == 80) {
        this.readonlyConscious100 = true;
        this.readonlyConscious90 = true;
      } else if (value == 70) {
        this.readonlyConscious100 = true;
        this.readonlyConscious90 = true;
        this.readonlyConscious80 = true;
      } else if (value == 70) {
        this.readonlyConscious100 = true;
        this.readonlyConscious90 = true;
        this.readonlyConscious80 = true;
      } else if (value == 60) {
        this.readonlyConscious100 = true;
        this.readonlyConscious90 = true;
        this.readonlyConscious80 = true;
        this.readonlyConscious70 = true;
      } else if (value == 50) {
        this.readonlyConscious100 = true;
        this.readonlyConscious90 = true;
        this.readonlyConscious80 = true;
        this.readonlyConscious70 = true;
        this.readonlyConscious60 = true;
      } else if (value == 40) {
        this.readonlyConscious100 = true;
        this.readonlyConscious90 = true;
        this.readonlyConscious80 = true;
        this.readonlyConscious70 = true;
        this.readonlyConscious60 = true;
        this.readonlyConscious50 = true;
      } else if (value == 30) {
        this.readonlyConscious100 = true;
        this.readonlyConscious90 = true;
        this.readonlyConscious80 = true;
        this.readonlyConscious70 = true;
        this.readonlyConscious60 = true;
        this.readonlyConscious50 = true;
        this.readonlyConscious40 = true;
      } else if (value == 20) {
        this.readonlyConscious100 = true;
        this.readonlyConscious90 = true;
        this.readonlyConscious80 = true;
        this.readonlyConscious70 = true;
        this.readonlyConscious60 = true;
        this.readonlyConscious50 = true;
        this.readonlyConscious40 = true;
        this.readonlyConscious30 = true;
      } else if (value == 10) {
        this.readonlyConscious100 = true;
        this.readonlyConscious90 = true;
        this.readonlyConscious80 = true;
        this.readonlyConscious70 = true;
        this.readonlyConscious60 = true;
        this.readonlyConscious50 = true;
        this.readonlyConscious40 = true;
        this.readonlyConscious30 = true;
        this.readonlyConscious20 = true;
      } else if (value == 10) {
        this.readonlyConscious100 = true;
        this.readonlyConscious90 = true;
        this.readonlyConscious80 = true;
        this.readonlyConscious70 = true;
        this.readonlyConscious60 = true;
        this.readonlyConscious50 = true;
        this.readonlyConscious40 = true;
        this.readonlyConscious30 = true;
        this.readonlyConscious20 = true;
        this.readonlyConscious10 = true;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/tools/pps-tool/pps-tool.ts